import script from "./CreateVacancy.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateVacancy.vue?vue&type=script&setup=true&lang=js"

import "./CreateVacancy.vue?vue&type=style&index=0&id=d319caea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d319caea"]])

export default __exports__